module.exports = __webpack_public_path__ + "static/14-7244f3665b2d91890f23ea276a3efce1.png";